import React, { createContext, useContext, useEffect, useState } from "react";
import { api, setAuth, clearAuth, getToken, getStoredUser, getStoredTenant } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(getStoredUser());
  const [tenant, setTenant] = useState(getStoredTenant());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const t = getToken();
      if (!t) {
        setLoading(false);
        return;
      }
      try {
        const { data } = await api.get("/auth/me");
        setUser(data.user);
        setTenant(data.tenant);
      } catch (e) {
        clearAuth();
        setUser(null);
        setTenant(null);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (email, password, totp_code) => {
    const { data } = await api.post("/auth/login", { email, password, totp_code });
    if (data.requires_totp && !data.access_token) {
      return { requires_totp: true };
    }
    setAuth(data.access_token, data.user, data.tenant);
    setUser(data.user);
    setTenant(data.tenant);
    return { user: data.user };
  };

  const logout = () => {
    clearAuth();
    setUser(null);
    setTenant(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, tenant, loading, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
